/** Must match server `PROMO_COUPON_CODE_MAX_LENGTH`. */
export const PROMO_COUPON_CODE_MAX_LENGTH = 64;

/** Must match server `PROMO_COUPON_CODE_PATTERN` in promoCoupon.constants.js */
export const PROMO_COUPON_CODE_PATTERN = /^[A-Za-z0-9._%-]+$/;

/** Shown under the input; server uses the same rules as `sanitizeInput` (plus `%`), then this charset. */
export const PROMO_COUPON_CODE_FORMAT_HINT =
  'Letters, numbers, and - _ . % only — no spaces. Dangerous characters (like < or quotes) are blocked.';

export const COUPON_REDEEM_COPY = {
  TITLE: 'Redeem Coupon',
  ENTRY_SUBTITLE: 'Enter your code exactly as issued',
  SUCCESS_SUBTITLE: "You're all set",
  SUCCESS_LABEL: 'Added to your balance',
  INPUT_PLACEHOLDER: 'Coupon code',
  INPUT_A11Y_LABEL: 'Coupon code',
  REDEEM_BUTTON: 'Redeem',
  DONE_BUTTON: 'Done',
  ERROR_EMPTY_CODE: 'Enter a coupon code',
  ERROR_GENERIC: 'Could not redeem',
  A11Y_CLOSE: 'Close redeem coupon',
  A11Y_REDEEM: 'Redeem coupon',
  A11Y_DONE: 'Done',
  HERO_ALT: 'Gift and coupon illustration for redeem code',
} as const;

export const couponMaxLengthError = (maxLength: number): string =>
  `Code must be at most ${maxLength} characters`;
